<template>
  <div class="emergencyhandlecard section-main__warp">
    <ioc-table
      ref="crud"
      :data="processCardList"
      :option="option"
      :page="page"
      @search-change="query"
      @search-reset="reset"
      @size-change="sizeChange"
      @current-change="pageChange"
      @selection-change="handleSelectionChange"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleAddCard"
          v-auth="'/workshop/emergency-handle-card:add'"
        >
          新增
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-delete"
          class="iss-operation-button"
          v-auth="'/workshop/emergency-handle-card:delete'"
          @click="deleteBatch"
        >
          批量删除
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="编辑"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai"
            @click="handleAddCard(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            :disabled="!scope.row.dataType"
            icon="iconfont icon-shanchu"
            @click="deleteRow(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
      <template slot="fileCode" slot-scope="scope">
        <el-image
          :src="getImgPath(scope.row.fileCode)"
          style="height: 25px; width: 50px"
          :preview-src-list="getSrcList(scope.row.fileCode)"
        />
      </template>
    </ioc-table>
    <!--新增处置卡-->
    <appPanel
      class="app-panel"
      :isExpand="showDialog"
      @cancel="resetForm('form')"
      :title="dialogTitle"
    >
      <!-- <el-dialog
      width="680px"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      @close="resetForm('form')"
    > -->
      <el-scrollbar>
        <el-form
          ref="form"
          label-width="120px"
          :rules="rules"
          style="padding: 24px; position: relative"
          :model="form"
        >
          <el-col :span="24">
            <el-form-item
              :label="$t('emergencyHandle.label.image')"
              prop="fileCode"
            >
              <el-upload
                ref="upload"
                class="avatar-uploader"
                action="common/file/batchFileload.json"
                :show-file-list="false"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-exceed="fileCount"
                :on-success="handleSuccess"
                :before-upload="beforeAvatarUpload"
                accept="image/png, image/jpg, image/jpeg, image/bpm"
                name="files"
                :auto-upload="true"
              >
                <img
                  class="avatar"
                  v-if="form.fileCode"
                  :src="getImgPath(form.fileCode)"
                  alt=""
                  style="width: 148px; height: 148px"
                />
                <i
                  v-else
                  class="
                    el-icon-plus
                    avatar-uploader-icon
                    el-upload--picture-card
                  "
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item
              :label="$t('emergencyHandle.label.handleName')"
              prop="cardName"
            >
              <el-input
                v-model="form.cardName"
                :placeholder="$t('emergencyHandle.placeholder.handleName')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('emergencyHandle.label.handleDevice')"
              prop="deviceName"
            >
              <el-input
                v-model="form.deviceName"
                :placeholder="$t('emergencyHandle.placeholder.handleDevice')"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item
              label-width="120px"
              prop="buildingNames"
              :label="$t('emergencyHandle.label.handleBuilding')"
            >
              <el-input
                v-model="form.buildingNames"
                placeholder="请选择楼栋"
                readonly
                :title="form.buildingNames"
              >
              </el-input>
              <el-button
                type="text"
                size="medium"
                style="position: absolute; right: 10px; font-size: 16px"
                class="iconfont icon-position map-choose"
                @click="choiceClick"
                title="选择楼栋"
              ></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('emergencyHandle.label.remark')"
              prop="desc"
            >
              <el-input
                type="textarea"
                :rows="5"
                maxlength="200"
                show-word-limit
                :placeholder="$t('emergencyHandle.placeholder.remark')"
                v-model="form.desc"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="info"
          @click="resetForm('form')"
          :loading="btnLoading"
          >{{
            btnLoading ? "保存中" : $t("emergencyHandle.button.cancel")
          }}</el-button
        >
        <el-button
          type="primary"
          @click="saveForm('form')"
          :loading="btnLoading"
        >
          {{ btnLoading ? "保存中" : $t("emergencyHandle.button.save") }}
        </el-button>
      </div>
      <!-- </el-dialog> -->
    </appPanel>
    <region-tree ref="regionTree" @saveChecked="saveChecked" />
  </div>
</template>

<script>
import { Bus } from "$utils";
import regionTree from "@src/modules/workshopEmergencyHandle/components/RegionTree.vue";
import tableOption from "../const/handleCardTable";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    regionTree,
    appPanel,
  },
  data() {
    return {
      btnLoading: false,
      queryForm: {},
      option: tableOption(this),
      page: {
        cardName: "",
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      processCardList: [],
      fileList: [],
      menusData: [],
      menusDataProps: {
        children: "subBuildingList",
        label: "buildingName",
        id: "buildingCode",
      },
      imgFileList: [], // 保存名单中上传图片数组
      dialogImageUrl: "",
      dialogType: "add",
      showType: "add",
      isSHow: false,
      loading: true,
      showDialog: false,
      dialogTitle: "",
      doUpload: false,
      dialogVisible: false,
      searchString: "",
      refreshCallBack: (self, res) => {
        self.processCardList = res.returnObj.list;
        self.total = res.returnObj.total;
      },
      buildingCodeList: "",

      form: {
        cardCodeList: "",
        cardName: "",
        deviceName: "",
        buildingCodeList: "",
        buildingNames: "",
        fileCode: "",
        desc: "",
      },
      rules: {
        cardName: [
          {
            required: true,
            message: this.$t("emergencyHandle.message.handleName"),
            trigger: "blur",
          },
        ],
        buildingNames: [
          {
            required: true,
            // type: "array",
            message: this.$t("emergencyHandle.message.handleBuilding"),

            // validator: (rule, value, cb) => {
            //   if (!value) return cb(new Error("请选择处置卡所属楼栋"));
            //   cb();
            // },
            trigger: "blur",
          },
        ],
        deviceName: [
          {
            required: true,
            message: this.$t("emergencyHandle.message.handleDevice"),
            trigger: "blur",
          },
        ],

        fileCode: [
          {
            required: true,
            message: this.$t("emergencyHandle.message.handleImage"),
            trigger: "blur",
          },
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: this.$t("emergencyHandle.message.less200"),
            trigger: "blur",
          },
        ],
      },
      srcList: [],
    };
  },
  created() {
    this.$fetch("/cms/building/queryBuildingTree.json").then((res) => {
      if (res && res.success) {
        this.menusData = res.returnObj;
        this.recursionTree(this.menusData);
      }
    });
    this.queryHandleCardList();
  },
  watch: {
    imgFileList: {
      handler(newValue, oldValue) {
        // this.customForm.fileList = newValue
      },
      deep: true,
    },
    fileList: {
      handler(newValue, oldValue) {
        // this.customForm.fileList = newValue
      },
      deep: true,
    },
  },
  methods: {
    getSrcList(item) {
      return [this.getImgPath(item)];
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.queryHandleCardList();
    },
    pageChange(pageNum) {
      this.page.currentPage = pageNum;
      this.queryHandleCardList();
    },
    beforeAvatarUpload(file) {
      const isImg = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/bpm",
      ].includes(file.type);
      if (!isImg)
        this.$message.error("图片类型错误,只能是png/jpg/jpeg/bpm中的一种");
      return isImg;
    },

    handleAddCard(row) {
      // console.log(row);
      this.showDialog = true;

      // this.recursionTree(this.menusData);
      if (row.cardCode) {
        // console.log("enter");

        this.form.cardName = row.cardName;
        this.form.buildingNames = row.buildingNames;
        // console.log(row);
        // console.log(row.buildingNames);
        this.form.cardCode = row.cardCode;
        this.form.deviceName = row.deviceName;
        this.form.desc = row.desc;
        this.form.fileCode = row.fileCode;
        this.form.buildingCodeList = [];
        this.showType = "edit";
        // console.log(this.form.cardCode);
        const param = {
          cardCode: this.form.cardCode,
        };
        this.$fetch("/bas/emergency/queryEmergencyCardDetail.json", param).then(
          (response) => {
            this.form.buildingNames = response.returnObj.buildingNames;
            this.treeData = response.returnObj;
            this.form.buildingCodeList = response.returnObj.buildingCodeList;
            // this.recursionTree(this.treeData);
            // console.log(this.treeData);
            const buildingCodes = this.treeData.buildingCodeList;
            // console.log(buildingCodes);
            // this.$nextTick(() => {});
            // console.log(this.data);
            // this.$refs.tree.setCheckedKeys(this.data);
          }
        );

        this.dialogTitle = this.$t("emergencyHandle.title.editHandleCard");
      } else {
        // console.log(row, "row");
        this.form.cardName = "";
        this.form.deviceName = "";
        this.form.buildingNames = "";
        this.form.desc = "";
        this.form.buildingCodeList = "";
        this.showType = "add";
        this.dialogTitle = this.$t("emergencyHandle.title.addHandleCard");
      }
    },

    handleSuccess(res, file, fileList) {
      // console.log(res, "resss");
      if (res.success) {
        this.form.fileCode = res.returnObj[0].fileId;
        // console.log("handleSuccess");
      }
    },
    //批量删除应急卡组
    deleteBatch() {
      const self = this;
      if (self.multipleSelection && self.multipleSelection.length > 0) {
        self
          .$confirm(
            self.$t("emergencyHandle.message.batchDeltips"),
            self.$t("emergencyHandle.title.warn"),
            {
              confirmButtonText: self.$t("emergencyHandle.button.confirm"),
              cancelButtonText: self.$t("emergencyHandle.button.cancel"),
              type: "warning",
            }
          )
          .then(() => {
            const cardCodeList = [];
            self.multipleSelection.forEach((item) => {
              cardCodeList.push(item.cardCode);
            });
            const param = {};
            param.cardCodeList = cardCodeList;
            self
              .$fetch("/bas/emergency/deleteEmergencyCard.json", param)
              .then((response) => {
                // 删除成功
                if (response.success) {
                  self.queryHandleCardList();
                  self.$message({
                    type: "success",
                    message: self.$t("emergencyHandle.message.batchDel"),
                  });
                } else {
                  self.$message.error(response.msgContent);
                }
              });
          })
          .catch(function (error) {
            // console.log(error);
          });
      } else {
        self.$message({
          type: "warning",
          message: self.$t("emergencyHandle.message.selecttips"),
        });
      }
    },
    deleteRow(row) {
      this.$confirm(this.$t("emergencyHandle.message.deltips"), "删除确认", {
        confirmButtonText: this.$t("emergencyHandle.button.confirm"),
        cancelButtonText: this.$t("emergencyHandle.button.cancel"),
        type: "warning",
        cancelButtonClass: "cancel-button-css",
      })
        .then(() => {
          const param = {};
          param.cardCodeList = [row.cardCode];
          this.$fetch("/bas/emergency/deleteEmergencyCard.json", param).then(
            (response) => {
              if (response.success) {
                this.$message({
                  type: "success",
                  message: this.$t("emergencyHandle.message.delSuccess"),
                });
                this.queryHandleCardList();
              } else {
                this.$message({
                  type: "error",
                  message: response.msgContent,
                });
              }
            }
          );
        })
        .catch(() => {});
    },

    saveForm(form) {
      if (this.showType === "add") {
        this.addHandleCard("form");
      } else {
        this.editHandleCard("form");
      }
    },
    resetForm(form) {
      this.showDialog = false;
      this.$refs["form"].resetFields();
      this.data = "";
      this.$refs.upload.clearFiles();
      this.form.fileCode = "";
    },
    addHandleCard(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            cardName: this.form.cardName,
            deviceName: this.form.deviceName,
            fileCode: this.form.fileCode,
            desc: this.form.desc,
            buildingCodeList: this.form.buildingCodeList,
          };
          this.btnLoading = true;
          this.$fetch("/bas/emergency/addEmergencyCard.json", params).then(
            (response) => {
              this.btnLoading = false;
              if (response.success) {
                this.$message({
                  type: "success",
                  message: this.$t("emergencyHandle.message.addSuccess"),
                });
                this.resetForm();
                this.queryHandleCardList();
              } else {
                this.$message({
                  type: "error",
                  message: response.msgContent,
                });
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    editHandleCard(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            cardName: this.form.cardName,
            deviceName: this.form.deviceName,
            fileCode: this.form.fileCode,
            desc: this.form.desc,
            cardCode: this.form.cardCode,
            buildingCodeList: this.form.buildingCodeList,
          };
          this.btnLoading = true;
          this.$fetch("/bas/emergency/updateEmergencyCard.json", params).then(
            (response) => {
              this.btnLoading = false;
              if (response.success) {
                this.$message({
                  type: "success",
                  message: this.$t("emergencyHandle.message.editSuccess"),
                });
                this.resetForm();
                this.queryHandleCardList();
              } else {
                this.$message({
                  type: "error",
                  message: response.msgContent,
                });
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    query(param) {
      this.page.pageNo = 1;
      this.queryForm = Object.assign({}, param);
      this.queryHandleCardList();
    },
    reset() {
      this.queryForm = {};
      this.page.pageSize = 10;
      this.queryHandleCardList();
    },
    handleSelectionChange(selected) {
      this.multipleSelection = selected;
    },

    saveChecked(data) {
      console.log(data);

      this.form.buildingCodeList = data.map((item) => {
        console.log(item);
        return item.buildingCode;
      });
      this.form.buildingNames = data
        .map((item) => {
          return item.buildingName;
        })
        .join("/");
    },
    choiceClick() {
      // this.$refs["regionTree"].openDialog(this.form.buildingCodeList);
      console.log(this.showType);
      // console.log(buildingCodeList);
      // if (this.showType === "edit") {
      this.$refs["regionTree"].openDialog(this.form.buildingCodeList);
      //   console.log(this.form.buildingCodeList);
      // } else {
      //   this.$refs["regionTree"].openDialog([]);
      // }
      // this.$nextTick(() => {
      //   this.$refs["tree"].setCheckedKeys(this.form.buildingCodeList || []);
      // });
    },
    // checkedKeys(data) {
    //   console.log(data);
    // },

    queryHandleCardList() {
      const params = {
        ...this.queryForm,
        // cardName: this.searchString,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      // const loading = this.$loading({
      //   lock: true,
      //   text: "请求中",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      this.$fetch("/bas/emergency/queryEmergencyCardList.json", params).then(
        (response) => {
          // setTimeout(() => {
          //   loading.close();
          // }, 500);
          this.processCardList = response.returnObj.list;
          this.page.total = response.returnObj.total;
        }
      );
    },
    recursionTree(data) {
      data.forEach((item) => {
        item.select = false;
        if (item.subBuildingList.length > 0) {
          this.recursionTree(item.subBuildingList);
        }
      });
    },

    // 图片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      // this.form.file = file.url;
      this.dialogVisible = true;
      this.doUpload = true;
    },
    buildingTypeChange() {},
    // 判断上传文件个数
    fileCount(file, fileList) {
      // this.$message.warning(this.$t("emergencyHandle.message.upWarn"));
    },
    // 添加图片
    handleChange(file, fileList) {
      // console.log("fileList", fileList, row);
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList);
        return false;
      }
      this.imgFileList = fileList;
      // this.form.fileCode = fileList;
      console.log("handleChange");
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = [
        "jpg",
        "png",
        "jpeg",
        "jpe",
        "dib",
        "bmp",
        "JPG",
        "PNG",
        "JPEG",
        "JPE",
        "DIB",
        "BMP",
      ];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);

      if (!isJPG) {
        this.$message.error(this.$t("emergencyHandle.message.formatWarn"));
        return false;
      }
      const Size = 1024 * 1024 * 4;
      if (file.size > Size) {
        this.$message.error(this.$t("emergencyHandle.message.sizeWarn"));
        return false;
      }
      return true;
    },
    deleteImg(file, fileList) {
      if (this.formState === 2) {
        if (file.status === "update") {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url;
          });
          this.fileList.splice(index, 1);
        } else {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url;
          });
          fileList.splice(index, 1);
        }
      } else {
        let index = this.fileList.findIndex((item) => {
          return item.url === file.url;
        });
        fileList.splice(index, 1);
      }
      console.log("deleImge");
    },
    // 删除图片
    handleRemove(file, fileList) {
      if (this.formState === 2) {
        if (file.status === "update") {
          let index = this.fileList.findIndex((item) => {
            return item.url === file.url;
          });
          this.fileList.splice(index, 1);
        }
      }
      console.log("handleRemove");
    },
  },
};
</script>

<style lang="scss" scoped>
.emergencyhandlecard {
  // width: 100%;
  display: flex;
  flex-direction: column;
  // padding: 0 10px;
  .choice-btn {
    position: absolute;
    // color: #0086ff;
    top: 0;
    right: 5px;
    z-index: 3;
  }

  .addProcess {
    padding: 10px 0;
    border-bottom: 1px solid #3e5574;
  }
  .filterProcess {
    margin: 10px 0;
  }
  .processTable {
    flex: 1;
  }
  .building {
    text-overflow: ellipsis;
    height: 40px;
  }
  .page-comp {
    margin: 10px 0;
  }
  .card-dialog {
    display: flex;
    box-sizing: border-box;
    width: 98%;
    height: 98%;
    margin: 0 auto;
    // .el-form-item__label {
    //   float: none;
    //   display: inline-block;
    //   text-align: left;
    //   padding: 0 0 10px;
    // }
    // .el-form-item__label:before {
    //   content: "*";
    //   color: #f56c6c;
    //   margin-right: 4px;
    // }
    // .el-col {
    //   margin-left: 20px;
    // }
    .scroll-bar {
      height: calc(100% - 30px);
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    // .el-upload {
    //   border: 1px dashed #d9d9d9;
    //   border-radius: 6px;
    //   background-color: #fbfdff;
    //   cursor: pointer;
    //   position: relative;
    //   overflow: hidden;
    // }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 48px;
      color: #8c939d;
      width: 200px;
      height: 200px;
      line-height: 200px;
      text-align: center;
    }
    .avatar {
      width: 200px;
      height: 200px;
      display: block;
    }
    .el-upload--picture-card {
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      width: 200px;
      height: 200px;
      line-height: 200px;
      vertical-align: top;
    }
  }
}
</style>
